import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-create-fee-group',
  imports: [SharedModule],
  templateUrl: './create-fee-group.component.html',
  styleUrl: './create-fee-group.component.scss'
})
export class CreateFeeGroupComponent {


  @Input() type: string = 'Create';
  @Input() feeGroupData: any;
  @Output() closeDialog = new EventEmitter();
  @Output() reload = new EventEmitter();
  @Input() users: any[] = []; // Assuming users are passed as input
  attachments: any[] = []; // Store selected files

  isSubmitted = false;
  btnLoading = false;

  @Input() allCourses: any[] = [];
  @Input() allAcademicYears: any[] = [];

  applicableOptions = [
    { label: "All Students", value: "All" },
    { label: "Undergraduate (UG)", value: "UG" },
    { label: "Postgraduate (PG)", value: "PG" },
    { label: "Diploma", value: "Diploma" },
    { label: "PhD / Doctoral", value: "PhD" },
    { label: "Certificate Courses", value: "Certificate" },
    { label: "Short-term / Training Programs", value: "ShortTerm" },
    { label: "International Students", value: "International" },
    { label: "Part-time / Evening Courses", value: "PartTime" }
  ];


  feeGroupForm: FormGroup;

  loading = false;


  statusOptions = [
    { label: "Active", value: true },
    { label: "Inactive", value: false }
  ];


  currencyOptions = [
    { label: "Indian Rupee (INR)", value: "INR" },
    { label: "US Dollar (USD)", value: "USD" },
    { label: "Euro (EUR)", value: "EUR" },
    { label: "British Pound (GBP)", value: "GBP" },
    { label: "Japanese Yen (JPY)", value: "JPY" },
    { label: "Australian Dollar (AUD)", value: "AUD" },
    { label: "Canadian Dollar (CAD)", value: "CAD" },
    { label: "Swiss Franc (CHF)", value: "CHF" },
    { label: "Chinese Yuan (CNY)", value: "CNY" },
    { label: "Singapore Dollar (SGD)", value: "SGD" },
    { label: "Hong Kong Dollar (HKD)", value: "HKD" },
    { label: "UAE Dirham (AED)", value: "AED" },
    { label: "Saudi Riyal (SAR)", value: "SAR" },
    { label: "South African Rand (ZAR)", value: "ZAR" }
  ];



  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private api: FeeService,
    private localStorage: LocalStorageService
  ) {
    this.feeGroupForm = this.fb.group({
      organization_id: [this.localStorage.getOrganizationId() || ''],
      campus_id: [this.localStorage.getCampusId() || ''],
      group_name: ['', Validators.required],
      description: [''],
      applicable_to: ['All'],   // default All
      academic_year_id: ['', Validators.required],
      department_id: [null],
      course_id: [null],
      total_fees: ['', Validators.required],
      currency: ['INR'],
      is_active: [true]
    });
  }

  ngOnInit() {
    if (this.type === 'Update' && this.feeGroupData) {
      console.log('Updating academic year with data:', this.feeGroupData);

      this.feeGroupForm.patchValue({
        group_name: this.feeGroupData.group_name,
        description: this.feeGroupData.description,
        applicable_to: this.feeGroupData.applicable_to,
        academic_year_id: this.feeGroupData.academic_year_id,
        department_id: this.feeGroupData.department_id,
        course_id: this.feeGroupData.course_id,
        total_fees: this.feeGroupData.total_fees,
        currency: this.feeGroupData.currency,
        is_active: this.feeGroupData.is_active,
        organization_id: this.feeGroupData.organization_id,
        campus_id: this.feeGroupData.campus_id
      });

    }


  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }

  onSubmit() {
    this.isSubmitted = true;

    if (this.feeGroupForm.valid) {
      const formValues = this.feeGroupForm.value;

      this.btnLoading = true;
      const payload = this.feeGroupForm.value;

      const apiCall = this.type === 'Create'
        ? this.api.createFeeGroup(payload)
        : this.api.updateFeeGroup({
          id: this.feeGroupData.id,
          ...payload
        });

      apiCall.subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: `Academic Year ${this.type === 'Create' ? 'created' : 'updated'} successfully` });
          this.feeGroupForm.reset();
          this.isSubmitted = false;
          this.reload.emit();
          this.handleCloseDialog();
          this.btnLoading = false;

        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: `Failed to ${this.type.toLowerCase()} Academic Year` });
          this.btnLoading = false;
        }
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: 'Please fill all required fields' });
    }
  }




}
